import { createElement as createReactElement } from 'react';
import { LocaleService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { getBreakpoint } from '@philips-internal/oswald-ui-utils';
import { ReactEngineBridge } from '../bridges/react-engine-bridge.js';
import { resolveProps, shouldRenderElement } from '../utils/index.js';
import { Renderer } from './renderer.js';
class ReactRenderer extends Renderer {
    constructor() {
        super(...arguments);
        this.cache = new Map();
    }
    createElement(component, props, children) {
        const breakpoint = this.getBreakpoint();
        const locale = LocaleService.getCurrentLocale();
        if (!shouldRenderElement(props, { breakpoint, locale })) {
            return null;
        }
        const _children = children ? children.map(this.traverseMetadata) : null;
        const resolvedProps = resolveProps(props, breakpoint, locale);
        return createReactElement(component, resolvedProps, _children);
    }
    getBreakpoint() {
        return getBreakpoint();
    }
    getComponentByType(node) {
        const { type } = node;
        if (!this.cache.has(type)) {
            const component = super.getComponentByType(node);
            const componentMetadata = super.getComponentMetadataByType(node);
            const decoratedComponent = ReactEngineBridge(component, componentMetadata);
            this.cache.set(type, decoratedComponent);
        }
        const component = this.cache.get(type);
        if (!component) {
            throw new Error(`[ReactRenderer]: Component not found: '${type}'`);
        }
        return component;
    }
}
export { ReactRenderer, };
//# sourceMappingURL=react-renderer.js.map